<app-role-access [placement]="'bottom'" [permission]="'ticket.change.status'" [action]="'disable'">
  <button
    data-role-element
    [ngbPopover]="TicketStatusChange"
    placement="bottom-left"
    *ngIf="isShowChangeStatus"
    triggers="manual"
    autoClose="outside"
    #p2="ngbPopover"
    (click)="toggleWithTicketStatusChangeContext(p2)"
  >
    <a class="link link--dotted-gray-dark">Изменить статус</a>
  </button>
</app-role-access>

<ng-template #TicketStatusChange>
  <app-loader *ngIf="ticketStatusesLoading || ticketStatusChangeLoading"></app-loader>
  <div class="w-320" *ngIf="!ticketStatusesLoading">
    <div *ngIf="!ticketStatusesError">
      <form (ngSubmit)="changeTicketStatus()" #changeStatusForm="ngForm">
        <div>
          <div class="mb-8">
            <span class="title title--s title--required">Новый статус</span>
          </div>
          <div class="grid">
            <div class="grid__box grid__box--size-6 mb-8" *ngFor="let status of ticketStatusesFiltered">
              <app-radio-button>
                <input
                  type="radio"
                  (change)="onStatusTypeChanged(status.id)"
                  id="{{ status.id }}"
                  name="statusType"
                  value="{{ status.id }}"
                  [(ngModel)]="statusTypeSelected"
                  required
                />
                <radio-button-text>{{ status.name }}</radio-button-text>
              </app-radio-button>
            </div>
          </div>
        </div>
        <div *ngIf="statusTypeSelected == 8" class="mt-16">
          <app-field>
            <label>
              <span class="title title--s title--required">Дата и время закрытия заявки</span>
            </label>
            <content-block>
              <div>
                <input type="hidden" id="ticketStatusDate" [ngModel]="statusTypeDate.dateObj && statusTypeDate.dateObj.dateMillis" (ngModelChange)="statusTypeDate.dateObj && (statusTypeDate.dateObj.dateMillis = $event)" name="statusDate" required />
                <app-date-time-picker
                  [initDate]="statusTypeDate.initDate"
                  [isShowTimepicker]="true"
                  [datepickerName]="'ticketStatusDateField'"
                  [options]="statusTypeDate.options"
                  (dateCallback)="onChangeStatusDate($event)"
                ></app-date-time-picker>
              </div>
            </content-block>
          </app-field>
          <div class="mt-8" *ngIf="!statusTypeDate.isNewStatusDateInvalid && statusTypeDate.dateObj && statusTypeDate.dateObj.dateMillis">
            <app-message [type]="'warning'">
              <div message-content>{{ ticketStatusWarning }}</div>
            </app-message>
          </div>
        </div>
        <div class="mt-16">
          <app-field>
            <label><span class="title title--s title--required">Причина смены статуса диспетчером</span></label>
            <textarea class="input-textarea" id="appComment" cols="45" rows="6" [(ngModel)]="comment" name="statusComment" required></textarea>
          </app-field>
        </div>
        <div *ngIf="ticketStatusChangeError" class="mt-16">
          <app-message [type]="'error'">
            <div message-content>{{ ticketStatusChangeError }}</div>
          </app-message>
        </div>
        <div class="mt-24">
          <button
            class="button"
            *ngIf="statusTypeSelected == 8"
            type="button"
            (click)="changeTicketStatus()"
            [disabled]="!changeStatusForm.form.valid || !statusTypeDate.isNewStatusDateInvalid"
          >
            Изменить
          </button>
          <button class="button" *ngIf="statusTypeSelected != 8" type="button" (click)="changeTicketStatus()" [disabled]="!changeStatusForm.form.valid">Изменить</button>
        </div>
      </form>
    </div>
    <div *ngIf="ticketStatusesError">
      <div class="mt-16">
        <app-message [type]="'error'">
          <div message-content>{{ ticketStatusesError }}</div>
        </app-message>
      </div>
    </div>
  </div>
</ng-template>
